import { BooleanColumn, NumericalColumn, DatetimeColumn, CategoricalColumn } from 'baseui/data-table';

export const COL_NAMES = {
	isDisabled: 'isDisabled',
	quantity: 'quantity',
	partnerName: 'partnerName',
	createdBy: 'createdBy',
	createdOn: 'createdOn',
	validFrom: 'validFrom',
	validTill: 'validTill',
	maxRedemptions: 'maxRedemptions',
	maxRedemptionsPerPerson: 'maxRedemptionsPerPerson'
};

export const columnConfigs = [
	BooleanColumn({
		title: 'Is Disabled',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled],
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Quantity',
		mapDataToValue: (data: any) => data[COL_NAMES.quantity] || '',
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Partner Name',
		mapDataToValue: (data: any) => data[COL_NAMES.partnerName] || '',
		maxWidth: 200
	}),
	CategoricalColumn({
		title: 'Created By',
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Max Redmpetions Per Code',
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptions] || '',
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Max Redmpetions Per Person',
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptionsPerPerson] || '',
		maxWidth: 200
	}),
	DatetimeColumn({
		title: 'Valid From',
		mapDataToValue: (data: any) => {
			const value = data[COL_NAMES.validFrom];
			return value && !Number.isNaN(new Date(value).getTime()) ? value : new Date('1990-01-01').getTime();
		},
		formatString: 'yyyy-MM-dd HH:mm',
		minWidth: 150,
		maxWidth: 200
	}),
	DatetimeColumn({
		title: 'Valid Till',
		mapDataToValue: (data: any) => {
			const value = data[COL_NAMES.validTill];
			return value && !Number.isNaN(new Date(value).getTime()) ? value : new Date('1990-01-01').getTime();
		},
		formatString: 'yyyy-MM-dd HH:mm',
		minWidth: 150,
		maxWidth: 200
	}),

	DatetimeColumn({
		title: 'Created On',
		mapDataToValue: (data: any) => new Date(data[COL_NAMES.createdOn]),
		maxWidth: 200,
		formatString: 'yyyy-MM-dd HH:mm'
	})
];
